import React from 'react';
import HeroSection from '../components/digital/HeroSection';
import Services from '../components/digital/Services';
import Outcomes from '../components/digital/Outcomes';
import Process from '../components/digital/Process';
import Feedback from '../components/digital/Feedback';
import Plans from '../components/digital/Plans';
import Experts from '../components/digital/Experts';
import FAQ from '../components/digital/FAQ';
import Contact from '../components/digital/Contact';

const Digital = () => {
  return (
    <>
      <HeroSection />
      <Services />
      <Outcomes />
      <Process />
      <Feedback />
      <Plans />
      <Experts />
      <FAQ />
      <Contact />
    </>
  )
}

export default Digital;